// Native
import { useState } from "react"
import { useParams } from "react-router"

// Components
import { ButtonGroup, Tag, Td, Badge, Tooltip } from "@chakra-ui/react"
import { Form, IconButton, Row, Searchable, Section, Table } from "components"

// Config
import { Moment, Enums, Mask } from "config"

// Hooks
import { useDistributor, useDistributorOrders, useScreens } from "hooks"

export default function Orders(){

    const params = useParams()
    const distributor = useDistributor(params?.id)
    const { setOrder } = useScreens()
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState()
    const [ status, setStatus ] = useState()
    const [ type, setType ] = useState()
    const orders = useDistributorOrders(distributor.data?.id, page, term, status, type)

    const columns = [
        { children: '' },
        { children: 'Cliente' },
        { children: 'Status' },
        { children: 'Valor', isNumeric: true },
        { children: 'Data', isNumeric: true },
        { children: '', isNumeric: true }
    ]

    return(
        <>
            <Section title="Pedidos de consultores">
                <ButtonGroup size="xs" isDisabled={orders.isFetching}>
                    <IconButton icon="refresh" isLoading={orders.isFetching} onClick={orders.refetch} />
                </ButtonGroup>
            </Section>

            <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por ID ou Código do pedido..">
                <Form.Select onChange={e => setType(e.target.value)} options={[{ label: 'Todos os pedidos', value: '' }, { label: 'Pedidos de Consultores', value: Enums.OrderType.CONSULTANT }, { label: 'Pedidos de Adesão', value: Enums.OrderType.ADHESION }]} />
                <Form.Select onChange={e => setStatus(e.target.value)} options={[{ label: 'Todos os status', value: '' }, { label: 'Aprovado', value: Enums.OrderStatus.APPROVED },{ label: 'Cancelado', value: Enums.OrderStatus.CANCELED }, { label: 'Em Análise', value: Enums.OrderStatus.ANALYZING }, { label: 'Em Trânsito', value: Enums.OrderStatus.SHIPPING }]} />
            </Searchable>

            <Table columns={columns} meta={orders.data?.meta} setPage={setPage} loading={orders.isLoading}>
                { orders.data?.data?.map(item => <Item key={item.id} onClick={() => setOrder(item) } data={item} />)}
            </Table>
        </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Row {...props}>
        <Td>
            {item.is_from_old_distributor ? (
                <Tooltip label="Pedido de núcleo transferido" hasArrow>
                    <Badge colorScheme="purple" variant="subtle" px="2" py="0.5" borderRadius="md">
                        {item.cod}
                    </Badge>
                </Tooltip>
            ) : item.cod}
        </Td>
        <Td fontWeight="bold" children={item.consultant?.customer?.name} />
        <Td><Tag size="sm" colorScheme={Enums.OrderStatus.data(item.status).colorScheme} children={item.status_label} /></Td>
        <Td isNumeric>R$ {Mask.price(item.total_amount)}</Td>
        <Td isNumeric fontSize="xs" children={Moment(item.created_at).calendar()} />
        <Td isNumeric><IconButton size="xs" label="Ver pedido" icon="view" /></Td>
    </Row>
)
